import request from '@/libs/request'

//剪枝记录 列表
export function plantCutListApi (data) {
  return request({
    url: `plant/plantCut`,
    method: 'get',
    params: data
  })
}

//剪枝记录 详情
export function plantCutInfoApi (id) {
  return request({
    url: `plant/plantCut/` + id,
    method: 'get'
  })
}


//剪枝记录 编辑/添加
export function plantCutSaveApi (data) {
  return request({
    url: `plant/plantCut`,
    method: 'post',
    data: data
  })
}

//剪枝记录 删除
export function plantCutDelApi (id) {
  return request({
    url: `plant/plantCut/` + id,
    method: 'delete'
  })
}

